import { render } from "./DriveoffPending.vue?vue&type=template&id=25180c09&scoped=true"
import script from "./DriveoffPending.vue?vue&type=script&lang=js"
export * from "./DriveoffPending.vue?vue&type=script&lang=js"

import "./DriveoffPending.vue?vue&type=style&index=0&id=25180c09&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25180c09"]])

export default __exports__